import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Dashboard from './pages/Dashboard';
import LeadManagement from './pages/LeadManagement';
import LeadDetail from './pages/LeadDetail';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import Scheduling from './pages/Scheduling';
import Financials from './pages/Financials';
import Expenses from './pages/Expenses';
import Notifications from './pages/Notifications';
import { SchoolProvider, useSchool } from './context/SchoolContext';
import AppLoader from './components/AppLoader';
import './App.css';

const AppContent = ({ isSidebarOpen, setIsSidebarOpen, isDesktop }) => {
  const { loading } = useSchool();
  return (
    <>
      <AppLoader appName="Receptionist Portal" loading={loading} />
      <div className="app-container">
        {isSidebarOpen && !isDesktop && (
          <div className="mobile-overlay" onClick={() => setIsSidebarOpen(false)} />
        )}
        <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} isDesktop={isDesktop} />
        <div className="main-content" style={{ marginLeft: isDesktop ? 'var(--sidebar-width)' : 0 }}>
          <Header setIsSidebarOpen={setIsSidebarOpen} isDesktop={isDesktop} />
          <div className="page-content">
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/leads" element={<LeadManagement />} />
              <Route path="/leads/:id" element={<LeadDetail />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/customers/:id" element={<CustomerDetail />} />
              <Route path="/scheduling" element={<Scheduling />} />
              <Route path="/financials" element={<Financials />} />
              <Route path="/expenses" element={<Expenses />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="*" element={<div>Page Not Found</div>} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
};

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  return (
    <SchoolProvider>
      <Router>
        <AppContent isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} isDesktop={isDesktop} />
      </Router>
    </SchoolProvider>
  );
}

export default App;
